////
/// ============================================================================
/// COMPONENT / Slider
/// ============================================================================
///
/// @link
/// @group components
////

import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgVideo from 'lightgallery/plugins/video';
import lgZoom from 'lightgallery/plugins/zoom';

export default () => {
    document.querySelectorAll(".js-video-gallery").forEach((video) => {
       // let id = video.getAttribute("id");
        let videoGallery = lightGallery(video, {
            plugins: [lgVideo],
            download: false,
            exitFullscreenOnClose: true,
        });

        video.addEventListener("click", () => {
            videoGallery.openGallery();
        });

    });

    document.querySelectorAll(".js-open-tourvirtual").forEach((tour) => {
        //let id = tour.getAttribute("id");
        let tourGallery = lightGallery(tour, {
                selector: 'this',
                download: false,
                exitFullscreenOnClose: true,

            });

        tour.addEventListener("click", () => {
            tourGallery.openGallery();
        });
    });

    document.querySelectorAll(".js-album").forEach((album) => {
        let id = album.getAttribute("id");

        if (lightGalleriesConfig && lightGalleriesConfig[id]) {
            let gallery = lightGallery(album, {
                plugins: [lgThumbnail, lgZoom],
                mode: 'lg-scale-up',
                download: false,
                dynamic: true,
                dynamicEl: lightGalleriesConfig[id],
                exitFullscreenOnClose: true,
            });

            album.addEventListener("click", () => {
                gallery.openGallery();
            });
        }
    });
};

